import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import TkTopAccordion from "../../components/molecules/TkTopAccordion";
import TkProcedureTable from "../../components/molecules/TkProcedureTable";
import SCRC090002 from "../SCRC090002";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import {
  httpAPI_APP002,
  httpAPI_APP013,
  httpAPI_APP014,
  httpAPI_APP017,
} from "./api/request";
import { HandleButton, ProcedureModal, TopInfo } from "./components/components";
import { navigatePath } from "./hooks/useTools";
import "./_style.scss";
import { ProcedureInfoList } from "../../type/apiType/IAPI_APP017";
import { LatestProcedureInfoList } from "../../type/apiType/IAPI_APP001";
import { HandleStatus } from "../../assets/data/Constants";

/**
 * SCRC020001 共済契約者ホーム
 * @return SCRC020001 共済契約者ホーム
 */
const SCRC020001 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { setState: setBusinessState } = useContext(BusinessContext);
  const [res, setRes] = useState<any>({});
  const [completedFlg, setCompleteFlg] = useState(false);
  const [procedureList, setProcedureList] = useState<any>([]);
  const [procedureHistoryList, setProcedureHistoryList] = useState<any>([]);
  const [threadId, setThreadId] = useState<number>();
  const [openThread, setOpenThread] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalButton, setModalButton] = useState<any>(<></>);
  const [modalItem, setModalItem] = useState({});
  const [openDelete, setOpenDelete] = useState(false);
  const [reqDelete, setReqDelete] = useState<any>({});
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCallApiInit = async () => {
    // 法人ホーム表示API　呼び出し
    try {
      const res = await httpAPI_APP017({
        userId: state.authInfo?.userId,
      });

      if (res.resultCd === "I0000") {
        res.procedureInfoList?.forEach((item: any) => {
          item.completedFlg = "0";
        });

        let procedureList = res.procedureInfoList?.map(
          (item: ProcedureInfoList) => {
            const button = (
              <HandleButton
                item={item}
                onClick={(e: any) => handleButtonClick(e, item, false)}
              />
            );

            return {
              important: item.importantFlg === "1",
              progress: item.latestApplyStatusName,
              date: item.dueDate,
              procedureName: item.businessTypeShortName,
              message: (
                <Link to="" onClick={() => handleLinkClick(item, button)}>
                  {item.procedureTitle}
                </Link>
              ),
              timing: item.executionName,
              children: button,
            };
          }
        );

        setProcedureList(procedureList);
        res.latestProcedureInfoList?.forEach((item: any) => {
          item.completedFlg = "1";
        });

        let procedureHistoryList = res.latestProcedureInfoList?.map?.(
          (item: LatestProcedureInfoList) => {
            return {
              important: item.importantFlg === "1",
              progress: item.latestApplyStatusName,
              date: item.dueDate,
              procedureName: item.businessTypeShortName,
              message: item.procedureTitle,
              timing: item.executionName,
              children: (
                <HandleButton
                  item={item}
                  onClick={(e: any) => handleButtonClick(e, item, true)}
                />
              ),
            };
          }
        );

        setProcedureHistoryList(procedureHistoryList);

        setRes(res);
        setCompleteFlg(!!state.taskCount && !res.procedureInfoList?.length);
        setIsExpanded(!!res.notificationInfoList?.length);

        setState({
          ...state,
          taskCount: res.procedureInfoList?.length,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleCallApi = async (button: any, data: ProcedureInfoList) => {
    setOpenDelete(false);
    let eventNum;
    switch (button) {
      case "確認":
        eventNum = HandleStatus["完了"];
        break;
      case "取下":
        eventNum = HandleStatus["取下"];
        break;
      case "不要":
        eventNum = HandleStatus["不要"];
        break;
      case "削除":
        eventNum = HandleStatus["削除"];
        break;
      case "完了":
        eventNum = HandleStatus["完了"];
        break;
      case "戻す":
        eventNum = HandleStatus["未対応"];
        break;
    }

    if (button === "取下" && data.businessType === "JOB-11") {
      // 掛金届の再提出API 呼び出し
      try {
        const res = await httpAPI_APP013({ applyId: data.applyId });

        if (res.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });

          navigate("/SCRC080001");
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
      return;
    }
    // 業務タイプが"JOB-45"(共済契約者との連絡掲示板（From：契約者　To：機構）) かつ　タスクタイトル = "機構からのメッセージがあります。" の場合
    if (
      data.businessType === "JOB-45" &&
      data.procedureTitle === "機構からのメッセージがあります。"
    ) {
      setThreadId(data.threadId);
      setOpenThread(true);
      return;
    }

    try {
      let res: any = {};

      switch (button) {
        case "確認":
        case "取下":
        case "不要":
        case "戻す":
        case "削除":
        case "完了":
          // 手続履歴状態更新API　呼び出し
          res = await httpAPI_APP002({
            taskId: data.taskId,
            contractorNo: state.authInfo?.contractorNo!,
            event: eventNum,
          });
          break;

        case "完了報告":
          // 共済法令違反による契約解除に対する従業状況更新API 呼び出し
          res = await httpAPI_APP014({ taskId: data.taskId });
          break;
      }

      if (res.resultCd === "I0000") {
        setCompleteFlg(!!state.taskCount && !res.procedureInfoList?.length);

        handleCallApiInit();

        setState({
          ...state,
          taskCount: res.procedureInfoList?.length,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleLinkClick = (item: any, button: any) => {
    if (item.businessType === "JOB-45") {
      setThreadId(item.threadId);
      setOpenThread(true);
    } else {
      setModalButton(button);
      setModalItem(item);
      setOpen(true);
    }
  };

  const handleClickHistoryComfirm = (item: any, isHistory: boolean) => {
    const dueDate = new Date(item?.dueDate);
    const fiscalYear =
      dueDate.getMonth() >= 3
        ? dueDate.getFullYear()
        : dueDate.getFullYear() - 1;

    navigate(
      navigatePath(
        item.businessType,
        isHistory,
        item.applyId && item.agentRequestFlg
      ),
      {
        state: {
          applyId: item.applyId,
          /**
           * IT_S_4427
           * 最近の手続き履歴一覧から遷移する場合、ステッパーを「８機構へ提出」に進める
           */
          stepFlg:
            item.businessType === "JOB-31" || item.businessType === "JOB-32",
          year: item?.businessType === "JOB-79" ? fiscalYear : null,
        },
      }
    );
  };

  const handleButtonClick = (
    name: any,
    item: ProcedureInfoList,
    isHistory: boolean
  ) => {
    setOpen(false);
    setBusinessState({
      common: { businessType: item.businessType },
    });

    switch (name) {
      case "確認":
        isHistory
          ? handleClickHistoryComfirm(item, isHistory)
          : handleCallApi(name, item);
        break;

      case "手続きへ":
        navigate(
          navigatePath(
            item.businessType,
            isHistory,
            item.applyId && item.agentRequestFlg
          ),
          {
            state: {
              ...(item.businessType !== "JOB-39" && { applyId: item.applyId }),
              staffNo: item.staffNo,
            },
          }
        );
        break;

      case "削除":
        setReqDelete(item);
        setOpenDelete(true);
        break;

      default:
        handleCallApi(name, item);
        break;
    }
  };

  return (
    <Box className="SCRC020001" data-testid="SCRC020001">
      <TopInfo item={res} />

      <TkTopAccordion
        notifications={res.notificationInfoList}
        expanded={isExpanded}
        onChange={() => setIsExpanded(!isExpanded)}
      />

      <TkProcedureTable
        procedureList={procedureList}
        buttonText="代行状況"
        buttonOnClick={() => navigate("/SCRC100001")}
        noDataMessage={
          <>
            {completedFlg && (
              <Typography className="noDataMessage">
                お疲れ様でした！
              </Typography>
            )}
            <Typography>現在必要な手続きはありません。</Typography>
          </>
        }
        maxHeight={400}
      />

      <TkProcedureTable
        procedureList={procedureHistoryList}
        title="最近の手続き履歴"
        historyLink="/SCRC070101"
        titleChangeToUpdateDay={true}
        maxHeight={400}
      />

      <SCRC090002
        threadId={threadId}
        open={openThread}
        onClose={() => setOpenThread(false)}
      />

      <ProcedureModal
        open={open}
        button={modalButton}
        item={modalItem}
        onClose={() => setOpen(false)}
      />

      <TkMessageDialog
        open={openDelete}
        onOky={() => handleCallApi("削除", reqDelete)}
        onCancel={() => setOpenDelete(false)}
        title="確認（一時保存データ削除）"
        contextText="一時保存データを削除しますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRC020001;
